import * as React from 'react'
import Box from '@mui/material/Box'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { ERole } from '@/store/apis/users'
import { useTranslation } from 'react-i18next'

interface IRoleDropDown {
  label?: string
  defaultValue: ERole
  onChange: (values: ERole) => void
}

const RoleDropDown: React.FC<IRoleDropDown> = ({
  label,
  defaultValue,
  onChange,
}) => {
  const { t } = useTranslation()
  const [role, setRole] = React.useState(defaultValue)
  let disabled = true

  const handleChange = (event: SelectChangeEvent) => {
    setRole(event.target.value as ERole)
    onChange(event.target.value as ERole)
  }
  if (role === ERole.User || role === ERole.SchemaCreator) {
    disabled = false
  }

  return (
    <>
      {!disabled ? (
        <Box sx={{ minWidth: 120 }}>
          <FormControl fullWidth>
            {label && <InputLabel>{t('roleType.role')}</InputLabel>}
            <Select
              value={role}
              label={label !== undefined ? label : 'Roll'}
              onChange={handleChange}
            >
              <MenuItem value={'USER'}>{t('roleType.user')}</MenuItem>
              <MenuItem value={'ATTENDANCER'}>
                {t('roleType.attendancer')}
              </MenuItem>
              <MenuItem value={'SCHEMA_CREATOR'}>
                {t('roleType.schema_creator')}
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
      ) : (
        t(`roleType.${role.toLocaleLowerCase()}`)
      )}
    </>
  )
}

export default RoleDropDown
